import baseConfigs from './base.theme';
import darkThemePalette from './dark.theme';
import lightThemePalette from './light.theme';
import InvalidThemeModeError from '@app/errors/InvalidThemeModeError';

export default function getThemeConfigurations(type) {
  if (!['light', 'dark'].includes(type)) throw new InvalidThemeModeError();
  if (type === 'light') return Object.assign(lightThemePalette, baseConfigs);
  return Object.assign(darkThemePalette, baseConfigs);
}
